import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private afs: AngularFirestore) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return await this.afs.collection('adminUsers').doc(localStorage.getItem('currentUserId')).ref.get().then(data => {
            if (data.exists) {
                if (data.data().roles) {
                    return true;
                }
                else {
                    this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
                    return false;
                }
            }
            else {
                this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
                return false;

            }
        });

    }
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/_guards/auth.guard.ts